import { useCallback, useEffect } from 'react';
import { QueryClient } from 'react-query';

import { ApplicationEventNames } from '~/constants/ApplicationEvents';
import { SentryHelper } from '~/helpers/Sentry/SentryHelper';

export const TradingEventListeners = ({ queryClient }: { queryClient: QueryClient }) => {
    const updateTrading = useCallback(() => {
        void queryClient.invalidateQueries().catch((e) => {
            console.error('Failed to invalidate queries', e);
            SentryHelper.captureException(e);
        });
    }, [queryClient]);

    useEffect(() => {
        window.addEventListener(ApplicationEventNames.OrderCanceled, updateTrading);
        window.addEventListener(ApplicationEventNames.TradeInitiated, updateTrading);
        window.addEventListener(ApplicationEventNames.DepositModalClosed, updateTrading);

        return () => {
            window.removeEventListener(ApplicationEventNames.OrderCanceled, updateTrading);
            window.removeEventListener(ApplicationEventNames.TradeInitiated, updateTrading);
            window.removeEventListener(ApplicationEventNames.DepositModalClosed, updateTrading);
        };
    }, [updateTrading]);

    return null;
};
